import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RteMaterialModule, RteLibraryModule } from 'rte-library';
import { AngularMaterialBaseModule } from 'src/app/modules/angular-material-base.module';
import { TextMaskModule } from 'angular2-text-mask';
import { BaseShareDialogComponent } from './base-share-dialog/base-share-dialog.component';
import { MatAutocompleteModule, MatInputModule, MatProgressBarModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RteFormModule } from '../rte-form/rte-form.module';
import {MatChipsModule} from '@angular/material/chips';

@NgModule({
  declarations: [
    BaseShareDialogComponent,
  ],
  imports: [
    CommonModule,
    RteMaterialModule,
    RteLibraryModule,
    AngularMaterialBaseModule,
    TextMaskModule,
    MatInputModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    RteFormModule,
    MatChipsModule,
    MatProgressBarModule,
  ]
})
export class ShareModuleModule { }
